export const searchUser = searchQuery => user => {
  const fullName = user["firstname"] + " " + user["lastname"];
  return fullName.toLowerCase().includes(searchQuery.toLowerCase());
};
